__webpack_require__.p = "/munchkin-level-counter/";